<mat-form-field #formFieldContainer class="example-full-width" [floatLabel]="componentDefinition?.floatLabel">
  <mat-label
    #labelContainer  (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">{{componentDefinition?.label}}</mat-label>

  <div class="labelToolTipContainer"
    #tooltip="matTooltip"
    matTooltip="{{componentDefinition.label}}"
    [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>

  <input matInput
         [id]="elementName + document.documentId" [name]="componentDefinition?.name"
         [readonly]=true
         [formControl]="formControl"
         [errorStateMatcher]="matcher">
</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
